import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxGridNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M22.5 8.40002H1.5V10.2H22.5V8.40002Z" fill={color} />
      <path d="M22.5 13.8H1.5V15.6H22.5V13.8Z" fill={color} />
      <path d="M16.5 3.90002H14.7V20.1H16.5V3.90002Z" fill={color} />
      <path d="M9.3 3.90002H7.5V20.1H9.3V3.90002Z" fill={color} />
      <path
        d="M22.5 21.6H1.5C0.6715 21.6 0 20.9273 0 20.1V3.90002C0 3.07152 0.6715 2.40002 1.5 2.40002H22.5C23.3273 2.40002 24 3.07152 24 3.90002V20.1C24 20.9273 23.3273 21.6 22.5 21.6ZM3 18.6H21V5.40002H3V18.6Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxGridNsk.displayName = 'ToolboxGridNsk';
